export default __webpack_public_path__ + "img/f813b23aaf3aa8a55ac03999412468a3.svg";